const links: Array<{
  key: string,
  section: 'primary' | 'secondary',
  icon: string | null,
}> = [
  { key: 'home', icon: 'mdi-account', section: 'primary' },
  { key: '1on1', icon: 'mdi-video-account', section: 'primary' },
  { key: '21days', icon: 'mdi-calendar-star', section: 'primary' },
  { key: 'retreats', icon: 'mdi-tent', section: 'primary' },
  { key: 'testimonials', icon: 'mdi-comment-check-outline', section: 'primary' },
  // { key: 'faq', icon: 'mdi-frequently-asked-questions', section: 'secondary' },
  { key: 'contact', icon: 'mdi-email-outline', section: 'primary' },
]

const availableLanguages = [
  { text: 'English', value: 'en-US', },
  { text: 'Español (Peruvian)', value: 'es-PE', },
  { text: 'Lithuanian', value: 'lt-LT', },
]

const retreatPdf = 'dolama-mantas-retreat.pdf'

const telegramLink = 'https://telegram.me/DolamaMantas';

export {
  links,
  telegramLink,
  retreatPdf,
  availableLanguages,
}
